import { render, staticRenderFns } from "./PostulacionNacionalIndex.vue?vue&type=template&id=be18d576"
import script from "./PostulacionNacionalIndex.vue?vue&type=script&lang=js"
export * from "./PostulacionNacionalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports